import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';
export const useDeleteGroupe = () => {
  const { deleteData, isLoadingDeleteGroupe, errorDeleteGroupe } = useDeleteApi();

  const deleteGroupe = async (groupeId) => {
    const urldelete = `${url}groupes/${groupeId}/`;
    await deleteData(urldelete);
  };

  return { deleteGroupe, isLoadingDeleteGroupe, errorDeleteGroupe };
};